import qs from 'qs';
import { network } from 'services/network';

export const changeClusterType = (params) => {
    const querystring = qs.stringify(
        {
            ProjectId: params.projectId,
            clusterAbvs: params.clusterAbvs,
            clusterThreshold: params.clusterThreshold,
            minInCluster: params.minInCluster,
            clusterServiceType: params.clusterServiceType,
        },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/changeClusterType${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
